module.exports = __webpack_public_path__ + "img/broadcast-tiao-icon4.42e12d84.png";